







































import { Component, Prop, Emit, Ref, Watch } from 'nuxt-property-decorator'
import { cloneDeep, find, merge } from 'lodash'
import { ComponentVue } from '@/base'
import {
  AlertMessage,
  defaultSystemCode,
  ErrorMessage,
  SystemCode,
  systemCodeApi
} from '@/api'
import { AtomTextField } from '@/components/atoms'
import {
  defaultSystemCodeWithKey,
  SystemCodeWithKey
} from '@/api/models/system-code/SystemCodeWithKey'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import { MaskPattern } from '@/types'

// TODO 仮値、後々削除予定 by Matsubara
export interface ICodeItem {
  value: string
  codeKey: string
  title: string
}

@Component({
  components: {}
})
export default class InputCode extends ComponentVue {
  @Ref()
  textField!: AtomTextField

  @Prop({ type: String, required: true })
  codeKey!: string

  @Prop({ type: String })
  label!: string

  @Prop({ type: String })
  placeholder!: string

  @Prop({ type: String })
  value!: string

  @Prop({
    type: Boolean,
    default: false
  })
  hideName!: boolean

  @Prop({ type: Boolean, default: false })
  clearable!: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  hideDetails!: boolean

  @Prop({
    type: Number
  })
  maxLength!: number

  @Prop({ type: Array })
  rules!: any

  @Prop({ type: Boolean, default: false })
  erasable!: boolean

  @Prop({ type: Boolean, default: false })
  erase!: boolean

  @Prop({ type: Boolean, default: false })
  error!: boolean

  @Prop({ type: String, default: '' })
  errorMessage!: string

  @Prop({
    type: [Number, String],
    default: 5
  })
  rows!: number | string

  @Prop({
    type: Boolean,
    default: true
  })
  noResize!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  flat!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  outlined!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  autofocus!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  multiple!: boolean

  @Prop({
    type: Array,
    default: () => []
  })
  exclusionCodes!: string[]

  @Prop({
    type: Array,
    default: () => []
  })
  disabledCodes!: string[]

  // DataTable等で本コンポーネントを使用する際は動作が重くなる為、無駄なリクエストを投げないように事前に下記propsに渡して処理をする
  @Prop({
    type: Promise
  })
  defaultSystemCode!: Promise<SystemCodeWithKey>

  @Prop({
    type: Number,
    default: 20
  })
  eraseIconSize!: number

  @Prop({
    type: Boolean,
    default: false
  })
  force!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  convertLink!: boolean

  @Watch('codeKey')
  async onChangeCodeKey() {
    if (this.force && this.codeKey) {
      // 書誌編集ダイアログで、項目を追加後、正しく読み込めないため追加 by nagasu
      this.systemCode = await systemCodeApi.getSystemCodeWithKey(this.codeKey)
    }
  }

  systemCode: SystemCodeWithKey = defaultSystemCodeWithKey()

  systemCodeFetched: boolean = false

  get mask(): string {
    return this.multiple
      ? MaskPattern.HalfWidthOnly
      : 'X'.repeat(this.systemCode.length)
  }

  get name(): string {
    if (!this.codeKey || this.hideName || this.multiple) {
      return ''
    }

    const item = find<SystemCode>(
      this.systemCode.codes.filter(systemCode =>
        this.exclusionCodes.every(
          exclusionCode => exclusionCode !== systemCode.code
        )
      ),
      {
        codeKey: this.codeKey,
        code: this.value
      }
    )

    return item ? item.shortName || '' : ''
  }

  onInput(value: string) {
    this.$emit('input', value)

    const item = find<SystemCode>(
      this.systemCode.codes.filter(systemCode =>
        this.exclusionCodes.every(
          exclusionCode => exclusionCode !== systemCode.code
        )
      ),
      {
        codeKey: this.codeKey,
        code: value
      }
    )

    this.$emit(
      'input:system-code',
      item !== undefined
        ? cloneDeep(item)
        : merge(defaultSystemCode(), {
            codeKey: this.codeKey,
            code: value
          })
    )
  }

  created() {
    this.fetchSystemCode()
  }

  activated() {
    this.fetchSystemCode()
  }

  deactivated() {
    this.systemCodeFetched = false
  }

  async fetchSystemCode() {
    if (this.systemCodeFetched) return

    try {
      if (this.defaultSystemCode) {
        this.systemCodeFetched = true
        this.systemCode = await this.defaultSystemCode
      } else {
        this.systemCodeFetched = true
        this.systemCode = await systemCodeApi.getSystemCodeWithKey(this.codeKey)
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  onChange(value: string) {
    this.$emit('change', value)

    const item = find<SystemCode>(this.systemCode.codes, {
      codeKey: this.codeKey,
      code: value
    })
    this.$emit(
      'change:system-code',
      item !== undefined
        ? cloneDeep(item)
        : merge(defaultSystemCode(), {
            codeKey: this.codeKey,
            code: value
          })
    )
  }

  // 恐らく、systemCodeそのものを渡せば余計なプロパティを削除できるので余裕があるときに対応を取りたい
  onListClick(): void {
    // HACK アペンドアイコン押下によるブラーをAtomTextField全体で共通化するかはまだ検討中
    // HACK その為、仕様が確定したら削除する場合も有りうる
    if (document.activeElement !== null) {
      ;(document.activeElement as any).blur()
    }

    this.$modalCode.open({
      codeKey: this.codeKey,
      title: this.systemCode.name,
      defaultCode: this.value ?? '',
      systemCodes: this.systemCode.codes,
      multiple: this.multiple,
      exclusionCodes: this.exclusionCodes,
      disabledCodes: this.disabledCodes,
      codeLength: this.systemCode.length,
      onOkClick: (item: SystemCode | SystemCode[] | null) => {
        if (item !== null) {
          this.$emit(
            'input',
            Array.isArray(item)
              ? item.map(item => item.code).join(',')
              : item.code
          )
          this.$emit('input:system-code', item)
          this.$emit(
            'change',
            Array.isArray(item)
              ? item.map(item => item.code).join(',')
              : item.code
          )
          this.$emit('change:system-code', item)
        }
      }
    })
  }

  @Emit('click')
  onClick() {}

  @Emit('click:erase')
  onEraseButtonClick() {}

  @Emit('keydown:enter')
  onKeydownEnter() {}

  @Emit('convert')
  onConvert() {}
}
